import React from 'react'
import 'twin.macro'
import contactscroll from '../../../../../src/images/contactscroll.jpg'

export default function ScrollImage({withText}) {
    return (
        <div tw="relative w-full my-12">
  <div tw="absolute inset-x-0 bottom-0 h-1/2 bg-gray-100"></div>
  <div tw="max-w-7xl mx-auto sm:px-6 lg:px-8">
    <div tw="relative shadow-xl sm:rounded-2xl sm:overflow-hidden">
      <div tw="absolute inset-0">
        <img tw="h-full w-full object-cover" src={contactscroll} alt="" />
        <div tw="absolute inset-0 bg-secondary-700" style={{mixBlendMode: 'multiply'}}></div>
      </div>
      <div tw="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8">
        <h1 tw="md:px-40 md:py-24  text-center text-2xl font-extrabold tracking-tight sm:text-3xl lg:text-4xl">
          <span tw="block text-white">“IN THE END, WE ONLY REGRET THE CHANCES WE DIDN’T TAKE.”
</span>
          {/* <span tw="block text-secondary-200">customer support</span> */}
        </h1>
        <p tw="mt-6 max-w-lg mx-auto text-center text-xl text-secondary-200 sm:max-w-3xl">–LEWIS CARROLL</p>
      </div>
    </div>
  </div>
</div>

    )
}
